import React, { forwardRef, useImperativeHandle, useRef } from "react"
import { useScrollRestoration } from "@/hooks/use-scroll-restoration.ts"
import { cn } from "@/utils/styles.ts"

interface PageContentWrapperSmallProps {
  children: React.ReactNode
  className?: string
}

const PageContentWrapperSmall = forwardRef<
  HTMLDivElement,
  PageContentWrapperSmallProps
>(({ children, className }, ref) => {
  const internalRef = useRef<HTMLDivElement>(null)

  useScrollRestoration(internalRef)
  useImperativeHandle(ref, () => internalRef.current!)

  return (
    <div
      ref={internalRef}
      className="box-border h-[calc(var(--scrollable-content-small))] w-full overflow-y-auto overflow-x-hidden p-4 pb-[calc(16px+env(safe-area-inset-bottom))] md:h-full md:pb-4"
    >
      <div
        className={cn(
          "mx-auto w-full",
          "md:w-4/5",
          "lg:w-3/4",
          "xl:w-2/3",
          "2xl:w-1/2",
          className,
        )}
      >
        {children}
      </div>
    </div>
  )
})

export default PageContentWrapperSmall
